import React from "react";
import PropTypes from "prop-types";
import Icon from "./Icon";

const NotificationEmbed = props => {
  const { children, type = "info", bold = false } = props;

  return (
    <div
      className={`notification-embed notification-embed--${type} ${
        bold && `notification-embed--bold`
      }`}
    >
      <Icon name="bell" />
      <div className="notification-embed__text">{children}</div>
    </div>
  );
};

NotificationEmbed.propTypes = {
  type: PropTypes.string,
  bold: PropTypes.bool,
  children: PropTypes.node
};

export default NotificationEmbed;
